/** Shared UI tokens for coach directory / booking (not from CRS). */
export const COACH_TIER_BADGE_STYLES = {
  elite: { bg: '#0f172a', color: '#fff', label: 'Elite' },
  performance: { bg: '#e0f2fe', color: '#0369a1', label: 'Performance' },
  coach: { bg: '#ccfbf1', color: '#0f766e', label: 'Coach' },
};
